import Grid from "@mui/material/Grid";
import ReactMarkdown from "react-markdown";
import {useNotice} from "../Providers/NoticeProvider";
import ModalBase from "./ModalBase";

type Props = {
    show: boolean;
    handleClose: () => void;
};

const CourseQuestionModal = ({show, handleClose}: Props) => {
    const [notice] = useNotice();
    return (
        <ModalBase
            show={show}
            title={"Instructions"}
            hideConfirmButton={true}
            handleClose={handleClose}
        >
            <Grid>
                <Grid size={12}>
                    <ReactMarkdown className="markdown">
                        {notice.instructorInstructions}
                    </ReactMarkdown>
                </Grid>
            </Grid>
        </ModalBase>
    );
};

export default CourseQuestionModal;
